import { translate, translateFormatter } from '@manomano-internal/i18n/esm/placeholders';
export const {
  outlineBundleTranslationTermsLabel,
  outlineBundleTranslationTotalPriceLabel
} = translate({
  "outlineBundleTranslationTermsLabel": "Some products can be shipped separately",
  "outlineBundleTranslationTotalPriceLabel": "Total:"
});
export const outlineBundleTranslationButton = translateFormatter<{
  quantity: number;
}>("{quantity, plural, =0 {No products selected} =1 {Add this product to your basket} other {Add these # products to your basket}}", undefined, undefined, "en");